import {darkGray} from '@modifi/colors'
import {ButtonLink} from '@modifi/ui'
import styled from 'styled-components'

export const LocationIconWrapper = styled.div`
  width: 5%;
`

export const StyledButtonLink = styled(ButtonLink)`
  font-weight: 600;
  font-size: 16px;
`

export const AutoSuggestWrapper = styled.div`
  li {
    height: auto !important;
  }
`

export const SuggestionWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-self: center;
  width: 100%;
`

export const SuggestionCompanyName = styled.div`
  width: 50%;
  margin-right: 8px;
  font-size: 16px;
  color: ${darkGray};
`

export const SuggestionAddress = styled.div`
  width: 50%;
  font-size: 14px;
  color: ${darkGray};
  display: flex;
  align-items: center;
`

export const AddressText = styled.span`
  margin-left: 8px;
  width: 95%;
`

export const CompanyLabelWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 16px;
  padding-bottom: 16px;
`

export const SuggestionContainerDiv = styled.div`
  max-height: 300px;
  overflow-y: auto;
  z-index: 999;
`
